import React from 'react'
import Modal from 'react-modal'

const defaultOptions = {
  isStatic: false,
}

Modal.setAppElement('body')

export const withModalBuilder = modalOptions => ModalContent => props => {
  const options = { ...defaultOptions, ...modalOptions }
  const { isOpen, onClose } = props
  return (
    <Modal
      isOpen={isOpen}
      style={style}
      onRequestClose={!options.isStatic ? onClose : null}
    >
      <ModalContent {...props} />
    </Modal>
  )
}

const style = {
  overlay: {
    zIndex: 1000,
    display: 'flex',
  },
  content: {
    margin: 'auto',
    position: 'static',
    border: 'initial',
    background: 'initial',
    padding: '5px',
  },
}



// WEBPACK FOOTER //
// ./src/modules/modal/withModalBuilder.js